module.exports = __webpack_public_path__ + "media/images/image4-a84c19272616d11f35b4dc44694a5373.png";